import dynamic from 'next/dynamic';

const OCardWishlist = dynamic(() => import('./OCardWishlist').then(mod => mod.OCardWishlist));

export { OCardWishlist };
export type { OCardWishlistProps } from './OCardWishlist.types';
